import { useMemo } from 'react';
import { getArticlePreviewQuery, } from 'components/settings/components/sections/dixaMessenger/views/flow/components/shared/knowledgeBaseLinkPreview/api';
import { useElevioQuery } from 'components/settings/components/sections/dixaMessenger/views/flow/hooks/elevio/useElevioQuery';
export function usePublicElevioArticle({ id }) {
    const variables = useMemo(() => !id
        ? undefined
        : ({
            id,
            languageId: 'en',
            pageUrl: window.location.origin,
        }), [id]);
    const result = useElevioQuery({
        query: getArticlePreviewQuery,
        variables,
    });
    return useMemo(() => ({
        isLoading: result.isLoading,
        data: result.data,
        isError: !!result.error,
        error: result.error,
    }), [result]);
}
